<template>
  <VehicleDefaultImage
    v-if="type === 'VEHICLE'"
    class="relative"
    data-t="errorImage"
    :dense="dense"
    :size="size"
    :style="dense ? undefined : 'top: -2px'"
  />
  <AssetDefaultImage v-else :size="size" />
</template>

<script setup lang="ts">
import AssetDefaultImage from 'components/assets/AssetDefaultImage.vue';
import VehicleDefaultImage from 'components/vehicle/VehicleDefaultImage.vue';
import { ASSET_TYPES } from 'src/services/constants';

type AssetTypes = typeof ASSET_TYPES;

defineProps<{ dense?: boolean; size: number; type: keyof AssetTypes }>();
</script>
